import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useFederatedSearchNotifications } from '../federated-search/federated-search-context';
import { useDexResults } from './results/use-dex-results';

export const useDexNotification = () => {
    const { dexNextEnabled } = useEnabledFeatures();
    const { dexResultsStore } = useDexResults();

    const federatedSearchNotifications = useFederatedSearchNotifications();

    const count = dexNextEnabled
        ? federatedSearchNotifications.unreadQueryCount
        : dexResultsStore.notificationCount;
    const isUrgent = dexNextEnabled
        ? federatedSearchNotifications.hasUnreadHotHit
        : dexResultsStore.isNotificationUrgent;

    return {
        count,
        isUrgent,
    };
};
